export const ucd = {
  slug: "ucd",
  name: "University of California, Davis",
  colors: {
    primary1: "#fff",
    text: "#000",
  },
  fonts: {
    base: "Proxima Nova, sans-serif",
    url: "https://whitelabel.2u.com/cdn/v1/794cfb88-5e8b-476d-8772-efc66ab541b2/marketing/whitelabel.fonts.min.css?ver=1.0",
  },
};

